<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div style="float: right">
        <md-button class="md-primary" :disabled="isDisabled" @click="exportData()">Export</md-button>
      </div>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>group</md-icon>
          </div>
          <h4 class="title">Parents</h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">

            <!-- From Date -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <md-datepicker v-model="fromDate" md-immediately>
                  <label>From Date</label>
                </md-datepicker>
              </md-field>
            </div>

            <!-- To Date -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <md-datepicker v-model="toDate" md-immediately>
                  <label>To Date</label>
                </md-datepicker>
              </md-field>
            </div>

            <!-- Email -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <md-input type="text" placeholder="Email" v-model="email"></md-input>
              </md-field>
            </div>

            <!-- Device Purchase Status -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Device Purchase Status</label>
                <md-select v-model="devicePurchaseFilter">
                  <md-option value="">All</md-option>
                  <md-option value="Completed">Completed</md-option>
                  <md-option value="Incomplete">Incomplete</md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Tag Filter -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Tag</label>
                <md-select v-model="tagFilter">
                  <md-option value="">All</md-option>
                  <md-option
                    v-for="t in uniqueTags"
                    :key="t"
                    :value="t"
                  >{{ t }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-button class="md-primary" :disabled="isDisabled" @click="kidsParentsList()">Search</md-button>
            </div>
          </div>

          <hr>

          <!-- TABLE -->
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Email" md-sort-by="email">
                <a href="javascript:void(0)" @click="ByPassUserLogin(item.email)">
                  {{ item.email }}
                </a>
                <span class="badge badge-info" v-if="item.delegatedAccessUser == true">Delegated
                  <br>
                </span>
                <span v-if="item.name != item.email">{{ item.name }}</span>
              </md-table-cell>

              <md-table-cell md-label="Products">
                {{ getProductNames(item.cartData) }}
              </md-table-cell>

              <md-table-cell md-label="Device Purchase">
                <span
                  :class="[
                    'badge',
                    item.devicePurchaseStatus === 'Completed' ? 'badge-success' : 'badge-danger'
                  ]"
                >
                  {{ item.devicePurchaseStatus }}
                </span>
              </md-table-cell>

              <md-table-cell md-label="Review Request" md-sort-by="reviewRequestSentCount">
                {{ item.reviewRequestSentCount }}&nbsp;&nbsp;
                <button class="tag-btn-inside" :style="{'right':'unset', top: '30%'}" 
                @click="$router.push({ path: '/kid/review-request', query: { email: item.email }})">Request Review</button>
              </md-table-cell>

              <!-- TAG COLUMN (NEW) -->
              <md-table-cell md-label="Tag">
              <div class="tag-box">
                <input 
                  v-model="item.tag" 
                  placeholder="Add tag"
                  class="tag-input-with-btn"
                />
                <button class="tag-btn-inside" @click="updateTag(item)">Update</button>
              </div>
              </md-table-cell>




              <md-table-cell md-label="Created" md-sort-by="created_at">
                {{ HumanReadableDateFormat(item.created_at, true) }}
              </md-table-cell>
              

            </md-table-row>
          </md-table>

        </md-card-content>

        <!-- Pagination Footer -->
        <md-card-actions md-alignment="space-between">
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";
const d = new Date(new Date().getFullYear(), 0, 1);

const fromDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export default {
  components: { Pagination },

  computed: {
    queriedData() {
      let result = this.tableData;

      // Filter by Device Purchase Status
      if (this.devicePurchaseFilter) {
        result = result.filter(
          (item) => item.devicePurchaseStatus === this.devicePurchaseFilter
        );
      }

      // Filter by Tag
      if (this.tagFilter) {
        result = result.filter(
          (item) => (item.tag || "").toLowerCase() === this.tagFilter.toLowerCase()
        );
      }

      return result.slice(this.from, this.to);
    },

    uniqueTags() {
      const tags = this.tableData.map(t => t.tag).filter(Boolean);
      return [...new Set(tags)];
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) highBound = this.total;
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    total() {
      return this.tableData.length;
    }
  },

  data() {
    return {
      isDisabled: false,
      currentSort: "orderId",
      currentSortOrder: "asc",

      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },

      tableData: [],
      searchedData: [],

      email: "",
      fromDate: "",
      toDate: null,

      devicePurchaseFilter: "",
      tagFilter: "",
    };
  },

  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    kidsParentsList() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        email: this.email,
      };

      UsersDataService.kidsParentsList(data)
        .then((response) => {
          this.tableData = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    updateTag(item) {
      UsersDataService.updateParentTag({
        userId: item._id,
        tag: item.tag
      })
        .then(() => {
          this.$toast.success("Tag updated successfully");
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    ByPassUserLogin(email) {
      UsersDataService.ByPassUserLogin({ email })
        .then((response) => {
          window.open(
            "https://parent.mywingio.com?token=" + response.data.data.token,
            "_blank"
          );
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    getProductNames(cartData) {
      if (!cartData || !Array.isArray(cartData)) return "—";
      return cartData
        .map((c) => c?.productDetail?.name || "Unknown Product")
        .join(", ");
    },

    async exportData() {
        if (this.tableData.length > 0) {
          let exportData = [];
          for await (let data of this.tableData) {
            exportData.push([ data.email, data.name, data.reviewRequestSentCount, data.tag, data.created_at]);
          }
          this.DownloadSampleImportFile(exportData);
        } else {
          this.$toast.error("No data to export");
        }
    },
    DownloadSampleImportFile(exportData = "") {
        let csv = 'Email,Name,Review Req Count,Tag,Created On\n';
        if (exportData) {
          exportData.forEach((row) => {
              csv += row.join(',');
              csv += "\n";
          });
        }
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        if (exportData) {
          anchor.download = 'wingio-parents.csv';
        }
        anchor.click();
    },
  },

  beforeMount() {
    this.kidsParentsList();
  },

  watch: {
    devicePurchaseFilter() {
      this.pagination.currentPage = 1;
    },
    tagFilter() {
      this.pagination.currentPage = 1;
    },
  }
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

.tag-box {
  position: relative;
  width: 150px;
}

.tag-input-with-btn {
  width: 100%;
  height: 30px;
  padding: 5px 55px 5px 8px; /* space for button on the right */
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.tag-btn-inside {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.tag-btn-inside:hover {
  background: #6a1b9a;
}

</style>
